import React, { useContext, useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { Worker } from '../../../../app/models/Workers';
import { AuthContext } from '../../../../contexts/AuthContext';
import { FundsRequestDataForm, FundRequestReason, defaultWorkerTotal } from '../../../../app/models/Fund';
import ButtonCreate from '../../../../components/buttons/ButtonCreate';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import { Society } from '../../../../app/models/Society';

interface Props {
    fundsRequest: FundsRequestDataForm;
    setFundsRequest: (expense: FundsRequestDataForm) => void;
    reasons: FundRequestReason[];
    workers: Worker[];
    errorFields?: any;
    isEdit?: boolean;
    currencies: any[];
    societies?: Society[];
    byReason:boolean
}

const FundsRequestForm = ({
    fundsRequest,
    setFundsRequest,
    workers,
    reasons,
    currencies,
    societies,
    errorFields,
    isEdit=false,
    byReason
}: Props) => {

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const { auth } = useContext(AuthContext);

    const handleChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>,
        index= -1
    ) => {
        const { name, value } = e.target;
        const obj = { [name]: value };

        if(index !== -1){
            handleWorkerTotal(obj, index);
        }
        
        setFundsRequest({ ...fundsRequest, ...obj });
    };

    const handleChangeSelectTwo = (name: string, value: any, index= -1) => {

        const obj = { [name]: value };

        if(index !== -1){
            handleWorkerTotal(obj, index);
        }else {
            setFundsRequest({ ...fundsRequest, ...obj });
        }

        if(isEdit){
            setFundsRequest({ ...fundsRequest, ...obj });
        }

    };

    const handleWorkerTotal = (obj: any, index: number) => {

        const workerTotal = fundsRequest.worker_total ? fundsRequest.worker_total : undefined;

        if(workerTotal){
            const changedWorkerTotal =  workerTotal[index]
            const updatedWorkerTotal = {
                ...changedWorkerTotal,
                ...obj
            }
            workerTotal[index] = updatedWorkerTotal

            setFundsRequest({
                ...fundsRequest,
                worker_total: workerTotal
            })
        }
    }

    const workerOptions = workers.map((worker) => ({
        id: worker.id,
        name: worker.user
            ? worker.user.first_name + ' ' + worker.user.last_name
            : 'Nombre no disponible'
    }));

    const addRow = () => {

        const workerTotal = fundsRequest.worker_total
        workerTotal?.push(defaultWorkerTotal)

        setFundsRequest({
            ...fundsRequest,
            'worker_total': workerTotal
        })
    }

    const deleteRow = (index: number) => {
        const workerTotal = fundsRequest.worker_total

        if(workerTotal){
            const newWorkerTotal = [...workerTotal.slice(0, index), ...workerTotal.slice(index + 1)];
            setFundsRequest({
                ...fundsRequest,
                'worker_total': newWorkerTotal
            })
            setErrors(undefined);
        }

    }

    return (
        <>
            {byReason && !isEdit && <div className="row mb-2">
                <div className="col-md-12 needs-validation">
                    <label className="col-md-4 col-form-label">Motivo</label>
                    <div className="col-md-12">
                        <SelectTwo
                            name="transfer_reason_id"
                            id="transfer_reason_id"
                            inputValue={fundsRequest.transfer_reason_id}
                            options={SelectTwoMapperOptions(reasons)}
                            hasError={fieldHasError('transfer_reason_id') !== ''}
                            onChange={(value: any) =>
                                handleChangeSelectTwo('transfer_reason_id', value?.value)
                            }
                            placeholder={'Seleccione el motivo'}
                            onFocus={() => onFocusRemove('transfer_reason_id')}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('transfer_reason_id')}
                        </div>
                    </div>
                </div>
            </div>}

            {societies && <div className="row mb-2">
                <div className="col-md-12 needs-validation">
                    <label className="col-md-4 col-form-label">Sociedad</label>
                    <div className="col-md-12">
                        <SelectTwo
                            name="society_id"
                            id="society_id"
                            inputValue={fundsRequest.society_id}
                            options={SelectTwoMapperOptions(societies)}
                            hasError={fieldHasError('society_id') !== ''}
                            onChange={(value: any) =>
                                handleChangeSelectTwo('society_id', value?.value)
                            }
                            placeholder={'Seleccione la sociedad'}
                            onFocus={() => onFocusRemove('society_id')}
                            disabled={isEdit}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('society_id')}
                        </div>
                    </div>
                </div>
            </div>}

            {byReason && workers.length > 0 && <> 
                {!isEdit && <div className="row mt-3 mb-3">
                    <div className="col-auto align-self-center">
                        <ButtonCreate title='Nuevo trabajador' callbackCreate={addRow} />
                    </div>
                </div>}
                {fundsRequest.worker_total && fundsRequest.worker_total.map((item, index) => {
                    return (
                        <>
                            { index !== 0 && <hr /> }
                            <div className="mb-2 row">
                                <div className={`col-${isEdit ? 12 : 10}`}>
                                    <div className="row g-1">
                                    <div className="col-6">
                                            <label className="label">Trabajador</label>
                                            <SelectTwo
                                                name="worker_id"
                                                id="worker_id"
                                                inputValue={item.worker_id}
                                                options={SelectTwoMapperOptions(workerOptions)}
                                                hasError={fieldHasError(`worker_total[${index}].worker_id`) !== ''}
                                                onChange={(value: any) =>
                                                    handleChangeSelectTwo('worker_id', value?.value, index)
                                                }
                                                placeholder={'Trabajador'}
                                                disabled={isEdit}
                                                onFocus={() => onFocusRemove(`worker_total[${index}].worker_id`)}
                                            />
                                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                                {fieldErrorMessage(`worker_total[${index}].worker_id`)}
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <label className="label">Total</label>
                                            <input
                                                name="total"
                                                id="total"
                                                type="number"
                                                className={`form-control ${fieldHasError('total')}`}
                                                value={item.total}
                                                onChange={(e) => handleChange(e, index)}
                                                onFocus={() => onFocusRemove('total')}
                                                placeholder="Ingrese monto total"
                                            />
                                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                                {fieldErrorMessage('workertotal_id')}
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <label className="label">Moneda</label>
                                            <SelectTwo
                                                name="currency_id"
                                                id="currency_id"
                                                inputValue={item.currency_id}
                                                options={SelectTwoMapperOptions(currencies)}
                                                hasError={fieldHasError(`worker_total[${index}].currency_id`) !== ''}
                                                onChange={(value: any) =>
                                                    handleChangeSelectTwo('currency_id', value?.value, index)
                                                }
                                                placeholder={'Moneda'}
                                                onFocus={() => onFocusRemove(`worker_total[${index}].currency_id`)}
                                            />
                                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                                {fieldErrorMessage('currency_id')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { !isEdit &&
                                    <div className="col-md-2 mt-4">
                                        <div className="">
                                            <ButtonTableAction
                                                callbackFunction={() => deleteRow(index)}
                                                classIcon={'mdi mdi-delete'}
                                                colorIcon={'text-danger'}
                                                errorMessage={'No se puede eliminar este registro.'}
                                                title={'Eliminar'}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </>
                    )
                })}
            </>}


            {!byReason && workers.length > 0 && <> 
                {!isEdit && <div className="row mt-3 mb-3">
                    <div className="col-auto align-self-center">
                        <ButtonCreate title='Nuevo trabajador' callbackCreate={addRow} />
                    </div>
                </div>}
                {fundsRequest.worker_total && fundsRequest.worker_total.map((item, index) => {
                    return (
                        <>
                            { index !== 0 && <hr /> }
                            <div className="mb-2 row">
                                <div className={`col-${isEdit ? 12 : 10}`}>
                                    <div className="row g-1">
                                    <div className="col-4">
                                        <label className="label">Trabajador</label>
                                        <SelectTwo
                                            name="worker_id"
                                            id="worker_id"
                                            inputValue={item.worker_id}
                                            options={SelectTwoMapperOptions(workerOptions)}
                                            hasError={fieldHasError(`worker_total[${index}].worker_id`) !== ''}
                                            onChange={(value: any) =>
                                                handleChangeSelectTwo('worker_id', value?.value, index)
                                            }
                                            placeholder={'Trabajador'}
                                            disabled={isEdit}
                                            onFocus={() => onFocusRemove(`worker_total[${index}].worker_id`)}
                                        />
                                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                                            {fieldErrorMessage(`worker_total[${index}].worker_id`)}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <label className="label">Motivo</label>
                                        <SelectTwo
                                            name="transfer_reason_id"
                                            id="transfer_reason_id"
                                            inputValue={item.transfer_reason_id}
                                            options={SelectTwoMapperOptions(reasons)}
                                            hasError={fieldHasError(`worker_total[${index}].transfer_reason_id`) !== ''}
                                            onChange={(value: any) =>
                                                handleChangeSelectTwo('transfer_reason_id', value?.value, index)
                                            }
                                            placeholder={'Motivo'}
                                            onFocus={() => onFocusRemove(`worker_total[${index}].transfer_reason_id`)}
                                        />
                                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                                            {fieldErrorMessage(`worker_total[${index}].transfer_reason_id`)}
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label className="label">Total</label>
                                        <input
                                            name="total"
                                            id="total"
                                            type="number"
                                            className={`form-control ${fieldHasError('total')}`}
                                            value={item.total}
                                            onChange={(e) => handleChange(e, index)}
                                            onFocus={() => onFocusRemove('total')}
                                            placeholder="Ingrese monto total"
                                        />
                                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                                            {fieldErrorMessage('workertotal_id')}
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <label className="label">Moneda</label>
                                        <SelectTwo
                                            name="currency_id"
                                            id="currency_id"
                                            inputValue={item.currency_id}
                                            options={SelectTwoMapperOptions(currencies)}
                                            hasError={fieldHasError(`worker_total[${index}].currency_id`) !== ''}
                                            onChange={(value: any) =>
                                                handleChangeSelectTwo('currency_id', value?.value, index)
                                            }
                                            placeholder={'Moneda'}
                                            onFocus={() => onFocusRemove(`worker_total[${index}].currency_id`)}
                                        />
                                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                                            {fieldErrorMessage('currency_id')}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                { !isEdit &&
                                    <div className="col-md-2 mt-4">
                                        <div className="">
                                            <ButtonTableAction
                                                callbackFunction={() => deleteRow(index)}
                                                classIcon={'mdi mdi-delete'}
                                                colorIcon={'text-danger'}
                                                errorMessage={'No se puede eliminar este registro.'}
                                                title={'Eliminar'}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </>
                    )
                })}
            </>}

            
        </>
    );
};

export default FundsRequestForm;
